var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("generic-modal", {
        ref: "aiEmailTemplateModal",
        attrs: {
          id: "ai-email-template-modal",
          "modal-dialog-scrollable": true,
          "modal-dialog-size": "xl",
          "modal-class": "ai-email-template-modal",
          "footer-close-button": false,
          "header-close-button": false,
        },
        on: { hidden: _vm.handleHidden },
        scopedSlots: _vm._u([
          {
            key: "header-custom",
            fn: function () {
              return [
                _vm.currentType === "save" || _vm.currentType === "edit"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "ai-email-template-modal__header ai-email-template-modal__header--form",
                      },
                      [
                        _c("i", {
                          class: [
                            "fa",
                            _vm.currentType === "edit"
                              ? "fa-pencil-square-o"
                              : "fa-bookmark-o",
                            "ai-email-template-modal__header-icon",
                          ],
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "h4",
                            { staticClass: "ai-email-template-modal__title" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.currentType === "edit"
                                      ? _vm.$t("email.custom.editTemplate")
                                      : _vm.$t("email.custom.saveTemplate")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "ai-email-template-modal__subtitle",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.currentType === "edit"
                                      ? _vm.$t(
                                          "email.custom.editTemplateDescription"
                                        )
                                      : _vm.$t(
                                          "email.custom.saveTemplateDescription"
                                        )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "ai-email-template-modal__header ai-email-template-modal__header--load",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "ai-email-template-modal__header-badge",
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-files-o",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "h4",
                            {
                              staticClass:
                                "ai-email-template-modal__title ai-email-template-modal__title--themed",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("email.custom.selectTemplate")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "ai-email-template-modal__subtitle",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "email.custom.selectTemplateDescription"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _vm.currentType === "load"
                  ? _c("div", { staticClass: "template-picker" }, [
                      _c(
                        "div",
                        { staticClass: "template-picker__list" },
                        _vm._l(_vm.localSavedTemplates, function (template) {
                          return _c(
                            "button",
                            {
                              key: template.id || template.title,
                              class: [
                                "template-picker__item",
                                {
                                  "template-picker__item--selected":
                                    _vm.isSelectedTemplate(template),
                                  "template-picker__item--disabled":
                                    _vm.isInlineEditing,
                                },
                              ],
                              attrs: {
                                type: "button",
                                disabled: _vm.isInlineEditing,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectTemplate(template)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "template-picker__item-icon" },
                                [
                                  _c("i", {
                                    class: [
                                      "fa",
                                      _vm.isSelectedTemplate(template)
                                        ? "fa-folder-open-o"
                                        : "fa-file-text-o",
                                    ],
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "template-picker__item-copy" },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(template.title)),
                                  ]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(_vm._s(template.prompt)),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "template-picker__preview" },
                        [
                          _vm.selectedTemplate && !_vm.isInlineEditing
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "template-picker__preview-header",
                                  },
                                  [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(_vm.selectedTemplate.title)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "template-picker__actions",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "template-picker__edit-button",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.selectedTemplate.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openEditTemplate(
                                                  _vm.selectedTemplate
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-pencil",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "email.custom.editTemplateAction"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("inline-prompt", {
                                          attrs: {
                                            "action-type": "delete",
                                            placement: "left",
                                            disabled: !_vm.selectedTemplate.id,
                                            loading:
                                              _vm.deletingTemplateId ===
                                              _vm.selectedTemplate.id,
                                            "confirmation-text": _vm.$t(
                                              "email.custom.deleteTemplateConfirmation"
                                            ),
                                          },
                                          on: {
                                            accept: function ($event) {
                                              return _vm.handleDeleteTemplate(
                                                _vm.selectedTemplate
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "template-picker__preview-divider",
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "template-picker__preview-box",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "template-picker__preview-box-header",
                                      },
                                      [
                                        _c("h5", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("global.words.preview")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "template-picker__copy-button",
                                            attrs: {
                                              type: "button",
                                              "aria-label": _vm.$t(
                                                "email.custom.copyInstructions"
                                              ),
                                              title: _vm.$t(
                                                "email.custom.copyInstructions"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copyInstructionsToClipboard(
                                                  _vm.selectedTemplate.prompt
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-copy",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "template-picker__preview-text",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.selectedTemplate.prompt
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            : _vm.selectedTemplate && _vm.isInlineEditing
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "template-picker__preview-header",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "template-picker__edit-title",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "template-picker__edit-icon",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-pencil-square-o",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c("h4", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "email.custom.editTemplate"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "template-picker__edit-description",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "email.custom.editTemplateDescription"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "template-picker__preview-divider",
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ai-email-template-modal__field",
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "ai-email-template-modal__label",
                                        attrs: { for: "template-title" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("global.words.title")
                                            ) +
                                            " "
                                        ),
                                        _c("span", [_vm._v("*")]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.templateTitle,
                                          expression: "templateTitle",
                                        },
                                      ],
                                      staticClass:
                                        "ai-email-template-modal__input",
                                      attrs: {
                                        id: "template-title",
                                        placeholder: _vm.$t(
                                          "email.custom.saveTemplateTitlePlaceholder"
                                        ),
                                        maxlength: "40",
                                        required: "",
                                      },
                                      domProps: { value: _vm.templateTitle },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.templateTitle =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ai-email-template-modal__counter",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.templateTitle.length) +
                                            "/40\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ai-email-template-modal__field",
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "ai-email-template-modal__label",
                                        attrs: { for: "template-instructions" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "email.custom.templateBody"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("span", [_vm._v("*")]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.templateInstructions,
                                          expression: "templateInstructions",
                                        },
                                      ],
                                      staticClass:
                                        "ai-email-template-modal__textarea",
                                      attrs: {
                                        id: "template-instructions",
                                        rows: "6",
                                        placeholder: _vm.$t(
                                          "email.custom.placeholder"
                                        ),
                                        maxlength: "5000",
                                        required: "",
                                      },
                                      domProps: {
                                        value: _vm.templateInstructions,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.templateInstructions =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ai-email-template-modal__counter",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.templateInstructions.length
                                            ) +
                                            "/5000\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            : _c(
                                "div",
                                { staticClass: "template-picker__empty" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "email.custom.selectTemplateToPreview"
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                        ],
                        2
                      ),
                    ])
                  : _vm.currentType === "save" || _vm.currentType === "edit"
                  ? _c(
                      "div",
                      { staticClass: "ai-email-template-modal__body" },
                      [
                        _c(
                          "div",
                          { staticClass: "ai-email-template-modal__field" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "ai-email-template-modal__label",
                                attrs: { for: "template-title" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("global.words.title")) +
                                    " "
                                ),
                                _c("span", [_vm._v("*")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.templateTitle,
                                  expression: "templateTitle",
                                },
                              ],
                              staticClass: "ai-email-template-modal__input",
                              attrs: {
                                id: "template-title",
                                placeholder: _vm.$t(
                                  "email.custom.saveTemplateTitlePlaceholder"
                                ),
                                maxlength: "40",
                                required: "",
                              },
                              domProps: { value: _vm.templateTitle },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.templateTitle = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "ai-email-template-modal__counter",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.templateTitle.length) +
                                    "/40\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ai-email-template-modal__field" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "ai-email-template-modal__label",
                                attrs: { for: "template-instructions" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("email.custom.templateBody")
                                    ) +
                                    " "
                                ),
                                _c("span", [_vm._v("*")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.templateInstructions,
                                  expression: "templateInstructions",
                                },
                              ],
                              staticClass: "ai-email-template-modal__textarea",
                              attrs: {
                                id: "template-instructions",
                                rows: "5",
                                placeholder: _vm.$t("email.custom.placeholder"),
                                maxlength: "5000",
                                required: "",
                              },
                              domProps: { value: _vm.templateInstructions },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.templateInstructions = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "ai-email-template-modal__counter",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.templateInstructions.length) +
                                    "/5000\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "ai-email-template-modal__footer-actions" },
                  [
                    _c("simple-button", {
                      attrs: {
                        id: "back",
                        text: _vm.$t(_vm.secondaryButtonText),
                        type: "white",
                      },
                      on: { click: _vm.handleSecondaryAction },
                    }),
                    _vm._v(" "),
                    _c("simple-button", {
                      staticClass: "confirm",
                      attrs: {
                        text: _vm.$t(_vm.primaryButtonText),
                        loading: _vm.savingTemplate,
                        disabled: _vm.primaryButtonDisabled,
                      },
                      on: { click: _vm.handlePrimaryAction },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("generic-modal", {
        ref: "replaceInstructionsModal",
        attrs: {
          id: "replace-instructions-modal",
          "modal-dialog-size": "md",
          "modal-class": "replace-instructions-modal",
          "footer-close-button": false,
          "header-close-button": false,
        },
        scopedSlots: _vm._u([
          {
            key: "header-custom",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "replace-instructions-modal__header" },
                  [
                    _c("h4", [
                      _vm._v(
                        _vm._s(_vm.$t("email.custom.replaceInstructionsTitle"))
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "p",
                  { staticClass: "replace-instructions-modal__description" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("email.custom.replaceInstructionsDescription")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "replace-instructions-modal__actions" },
                  [
                    _c("simple-button", {
                      attrs: {
                        type: "white",
                        text: _vm.$t("global.words.cancel"),
                      },
                      on: { click: _vm.cancelReplaceInstructions },
                    }),
                    _vm._v(" "),
                    _c("simple-button", {
                      attrs: {
                        text: _vm.$t("email.custom.replaceAndLoadAction"),
                      },
                      on: { click: _vm.confirmReplaceInstructions },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }